<!--
  @author Simeon Artamonov <simeon@cross-works.co.uk>
  @company Cross Works Ltd
-->
<template>
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 20 20" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    class="x-icon"
  >
    <g clip-path="url(#clip0_2002_38051)">
      <path 
        d="M15.75 0.936768H18.8171L12.1171 8.61391L20 19.0625H13.8286L8.99143 12.7268L3.46286 19.0625H0.392857L7.55857 10.8482L0 0.938196H6.32857L10.6943 6.7282L15.75 0.936768ZM14.6714 17.2225H16.3714L5.4 2.68105H3.57714L14.6714 17.2225Z" 
        fill="var(--theme-link)"
      />
    </g>
    <defs>
      <clipPath id="clip0_2002_38051">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
// No props or computed properties needed as we're using CSS variables
</script>

<style lang="scss" scoped>
@use '../../assets/scss/variables' as *;
.x-icon path {
  transition: fill $animation-speed-medium ease-out;
}

.x-icon:hover path {
  fill: var(--theme-link-hover);
}

.x-icon:active path {
  fill: var(--theme-link-active);
}
</style>